import { createReducer, on } from '@ngrx/store';
import { AppInitRequestStatus } from '../enums/app-init-request-status.enum';
import * as AppInitActions from './app-init.actions';

export interface RequestStatus {
  key: string;
  status: AppInitRequestStatus;
}

export interface AppInitState {
  requiredRequests: string[];
  requestStatuses: { [key: string]: RequestStatus };
  isInitialized: boolean;
}

const initialState: AppInitState = {
  requiredRequests: [],
  requestStatuses: {},
  isInitialized: false,
};

export const appInitReducer = createReducer(
  initialState,

  on(AppInitActions.registerRequiredRequests, (state, { requestKeys }) => {
    const requestStatuses: { [key: string]: RequestStatus } = {};

    requestKeys.forEach((key) => {
      requestStatuses[key] = {
        key,
        status: AppInitRequestStatus.Pending,
      };
    });

    // If no required requests, immediately mark as initialized
    // If there are required requests, wait for them to complete
    const isInitialized = requestKeys.length === 0;

    return {
      ...state,
      requiredRequests: requestKeys,
      requestStatuses,
      isInitialized,
    };
  }),

  on(AppInitActions.markRequestComplete, (state, { requestKey }) => {
    const updatedStatuses = {
      ...state.requestStatuses,
      [requestKey]: {
        key: requestKey,
        status: AppInitRequestStatus.Success,
      },
    };

    const allComplete = state.requiredRequests.every(
      (key) => updatedStatuses[key]?.status === AppInitRequestStatus.Success
    );

    return {
      ...state,
      requestStatuses: updatedStatuses,
      isInitialized: allComplete,
    };
  }),

  on(AppInitActions.markRequestFailed, (state, { requestKey }) => {
    const updatedStatuses = {
      ...state.requestStatuses,
      [requestKey]: {
        key: requestKey,
        status: AppInitRequestStatus.Failed,
      },
    };

    return {
      ...state,
      requestStatuses: updatedStatuses,
      isInitialized: false,
    };
  }),

  on(AppInitActions.resetAppInit, () => initialState)
);

